/**
 * Utility functions used across multiple modules.
 */
export function decodeHTMLEntities(text) {
    const tempElement = document.createElement("textarea");
    tempElement.innerHTML = text;
    return tempElement.value;
}